module.exports = __webpack_public_path__ + "img/a5.eb88c1e2.jpg";